var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomRightQuarterCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 106,
    viewBox: "0 0 39 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.522 110.556C159.522 122.417 157.298 131.549 153.365 138.605C149.443 145.639 143.736 150.768 136.495 154.501C121.868 162.043 101.137 163.827 76.8198 163.827C53.2024 163.827 34.8944 154.497 22.4468 139.353C9.9575 124.159 3.24123 102.946 3.24123 79.0644C3.24123 55.194 9.94822 36.1918 22.3339 23.1708C34.7033 10.1668 53.0133 2.83694 76.8198 2.83694C100.069 2.83694 120.707 17.5551 135.652 38.6548C150.583 59.7331 159.522 86.7819 159.522 110.556Z",
    stroke: "url(#paint0_linear_1598_1282)",
    strokeWidth: 4.70903
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_1282",
    x1: 81.3817,
    y1: 0.482422,
    x2: 81.3817,
    y2: 166.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE68EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CAAC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightQuarterCircle);
export default __webpack_public_path__ + "static/media/BottomRightQuarterCircle.5e3f7beb.svg";
export { ForwardRef as ReactComponent };